import { useT } from "@/lib/i18n";

const CDN = "https://www.bosquesuspendido.com/wp-content/uploads";

export type CaseMention = { outlet: string; url: string };
export type FamousCase = {
  slug: string;
  year: string;
  area: string;
  role: string;
  headline: string;
  summary: string;
  imageUrl?: string;
  mentions: CaseMention[];
};

/**
 * Bosque Suspendido — programas temáticos y de multiaventura para escolares,
 * cumpleaños, grupos y empresas. Contenido editable vía tk().
 */
export function useCases(): FamousCase[] {
  const { tk } = useT();
  return [
    {
      slug: "indios-jaujopi",
      year: "Escolares",
      area: tk("cases.indios.area", "Programa temático"),
      role: tk("cases.indios.role", "Día completo monitorizado"),
      headline: tk("cases.indios.headline", "Indios JauJopi — un día en el poblado"),
      summary: tk(
        "cases.indios.summary",
        "Conocerán nuestro poblado indio y a la tribu Jau Jopi, sus costumbres y rituales. Practicarán tiro con arco, volarán en las tirolinas y elaborarán su propio amuleto. Cierran el día con la ceremonia del tótem y son bautizados con sus nombres indios.",
      ),
      imageUrl: `${CDN}/2021/09/BANNER-WEB-BS-2017-INDIOS-JAUJOPI-300x300-1.jpg`,
      mentions: [],
    },
    {
      slug: "parque-juliasico",
      year: "Escolares",
      area: tk("cases.juliasico.area", "Programa temático"),
      role: tk("cases.juliasico.role", "Día completo monitorizado"),
      headline: tk("cases.juliasico.headline", "Parque Juliásico — viaja a un tiempo remoto"),
      summary: tk(
        "cases.juliasico.summary",
        "El parque juliásico abrirá las puertas de su cueva prehistórica. Verán cómo vivían los trogloditas, cómo cazaban, elaborarán un fósil de recuerdo y conocerán cómo se buscan los fósiles de dinosaurios.",
      ),
      imageUrl: `${CDN}/2021/09/BANNER-WEB-BS-2017-PARQUE-JULIASICO-300x300-1.jpg`,
      mentions: [],
    },
    {
      slug: "al-abordaje",
      year: "Escolares",
      area: tk("cases.abordaje.area", "Programa temático"),
      role: tk("cases.abordaje.role", "Día completo monitorizado"),
      headline: tk("cases.abordaje.headline", "¡Al abordaje! ¡¡Ahí vienen los piratas!!"),
      summary: tk(
        "cases.abordaje.summary",
        "Nuestro galeón pirata es el escenario donde conocerán a toda la tripulación, participarán en la búsqueda del tesoro en la Isla del Cangrejo, elaborarán su moneda pirata y volarán en la tirolina desde la pasarela del barco.",
      ),
      imageUrl: `${CDN}/2021/09/BANNER-WEB-BS-2017-AL-ABORDAJE-300x300-1.jpg`,
      mentions: [],
    },
    {
      slug: "chocolate-aventura",
      year: "Escolares",
      area: tk("cases.chocolate.area", "Doble visita"),
      role: tk("cases.chocolate.role", "Jornada completa"),
      headline: tk("cases.chocolate.headline", "¡Chocolate y aventura! — un día de sabor"),
      summary: tk(
        "cases.chocolate.summary",
        "Combina una visita a una fábrica de delicioso chocolate con talleres relacionados, y por la tarde llega la aventura: 4 horas de actividades en el pinar.",
      ),
      mentions: [],
    },
    {
      slug: "al-galope-aventura",
      year: "Grupos",
      area: tk("cases.galope.area", "Doble visita"),
      role: tk("cases.galope.role", "Jornada de sensibilidad y emociones"),
      headline: tk("cases.galope.headline", "¡Al galope y aventura!"),
      summary: tk(
        "cases.galope.summary",
        "Combina una visita al Centro Ecuestre «El Acebuche» con 4 horas de aventuras en el Centro de Naturaleza La Juliana.",
      ),
      imageUrl: `${CDN}/2023/03/al-galope-aventura-1.png`,
      mentions: [],
    },
    {
      slug: "kayak-aventura",
      year: "Grupos",
      area: tk("cases.kayak.area", "Doble visita"),
      role: tk("cases.kayak.role", "Jornada completa"),
      headline: tk("cases.kayak.headline", "¡Kayak y aventura! — navega el Guadalquivir"),
      summary: tk(
        "cases.kayak.summary",
        "Navega en kayak por el Guadalquivir y visita Sevilla desde el río. Por la tarde, 4 horas de actividades de aventura.",
      ),
      mentions: [],
    },
  ];
}
